export default __webpack_public_path__ + "static/media/feedback-homecard.384f690a.svg";